import React from 'react';

/**
 * @param {{ label: string, value: React.ReactNode, hint?: string, icon?: string, tone?: 'default' | 'accent' | 'success' | 'warning' }} props
 */
export function StatCard({ label, value, hint, icon, tone = 'default', layout = 'default' }) {
  const toneClass = tone !== 'default' ? ` stat-card--tone-${tone}` : '';
  const layoutClass = layout === 'center' ? ' stat-card--layout-center' : '';
  return (
    <div className={`stat-card${toneClass}${layoutClass}`}>
      <div className="stat-card__top">
        {icon && (
          <span className="stat-card__icon" aria-hidden>
            {icon}
          </span>
        )}
        <span className="stat-card__label">{label}</span>
      </div>
      <div className="stat-card__value">{value}</div>
      {hint && <div className="stat-card__hint">{hint}</div>}
    </div>
  );
}
